var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h1",
      [
        _c("span", { staticStyle: { "margin-right": "20px" } }, [
          _vm._v("选择审批流程")
        ]),
        _c(
          "el-select",
          {
            attrs: { size: "mini", placeholder: "请选择审批流程" },
            on: { change: _vm.handleChangeApprovalFlow },
            model: {
              value: _vm.approvalFlowSelect,
              callback: function($$v) {
                _vm.approvalFlowSelect = $$v
              },
              expression: "approvalFlowSelect"
            }
          },
          _vm._l(_vm.approvalFlowList, function(v, index) {
            return _c("el-option", {
              key: index,
              attrs: { value: v.flowId, label: v.flowName }
            })
          }),
          1
        ),
        _c(
          "span",
          {
            staticStyle: {
              "margin-left": "20px",
              "font-weight": "400",
              "font-size": "12px"
            }
          },
          [
            _vm._v("\n      无可用流程，\n      "),
            _c(
              "span",
              {
                staticStyle: { color: "#ec1c1e", cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/console/flow" })
                  }
                }
              },
              [_vm._v("\n        立刻设置\n      ")]
            )
          ]
        )
      ],
      1
    ),
    _c("div", { staticClass: "f-center2" }, [
      _c("div", { staticClass: "bow" }, [
        _vm.flows.length > 0
          ? _c(
              "div",
              {
                staticStyle: {
                  border: "1px solid rgba(229, 229, 229, 1)",
                  "border-radius": "4px",
                  "margin-top": "12px"
                }
              },
              [
                _c("div", { staticStyle: { position: "relative" } }, [
                  _c(
                    "div",
                    { staticClass: "men-box" },
                    _vm._l(_vm.flows, function(user, i) {
                      return _c(
                        "div",
                        { key: user.emplId, staticClass: "mens-sty" },
                        [
                          _c("p", { staticClass: "men-item" }, [
                            _c("img", {
                              attrs: {
                                src: "/images/web/p-default.png",
                                width: "50px",
                                height: "50px",
                                alt: ""
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "name-warp",
                                attrs: { title: user.name }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(user.name) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm.flows.length > i + 1 &&
                          _vm.flowInfo.flowType === 1
                            ? _c("i", {
                                staticClass: "icon icon-audit-jiantou32"
                              })
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bcfa604", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bcfa604","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/dingTalkuse/flowPath.vue
// module id = 8ohe
// module chunks = 2 3 6 8 100 231